export default __webpack_public_path__ + "static/media/Group 1692@2x.889dffc5.png";